import { render, staticRenderFns } from "./Proforms.vue?vue&type=template&id=787dae02&"
import script from "./Proforms.vue?vue&type=script&lang=js&"
export * from "./Proforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports